import { useCallback, useEffect, useState } from 'react';

export const useMediaViewerListener = (): {
	isMediaOpen: boolean;
} => {
	const [isMediaOpen, setIsMediaOpen] = useState(false);

	const mediaMessageListener = useCallback(
		(messageEvent: MessageEvent) => {
			const { source, event } = messageEvent.data ?? {};
			if (!source || !event) {
				return;
			}
			if (source === 'media') {
				switch (event) {
					case 'mediaViewerOpened':
						setIsMediaOpen(true);
						break;
					case 'mediaViewerClosed':
						setIsMediaOpen(false);
						break;
					default:
						return;
				}
			}
		},
		[setIsMediaOpen],
	);

	useEffect(() => {
		window.addEventListener('message', mediaMessageListener);
		return () => window.removeEventListener('message', mediaMessageListener);
	}, [mediaMessageListener]);

	return { isMediaOpen };
};
